import React from "react";

const CategorySidebar = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <div className="bg-surface-default dark:bg-surface-default shadow rounded-lg">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Categories</h3>
      </div>
      <nav className="space-y-1 p-4">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${
              selectedCategory === category.id
                ? "bg-blue-50 text-blue-700"
                : "text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100"
            }`}
          >
            <span className="mr-3">{category.icon}</span>
            <span className="flex-1 text-left">{category.name}</span>
            <span className="ml-3 inline-block py-0.5 px-2 text-xs rounded-full bg-gray-100">
              {category.count}
            </span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default CategorySidebar;
